import { render, staticRenderFns } from "./TopHeader.CollectionEdit.vue?vue&type=template&id=2dab80db&"
import script from "SKYXH/components/topHeader.component.collectionEdit?vue&type=script&lang=js&"
export * from "SKYXH/components/topHeader.component.collectionEdit?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports